import { Box, Checkbox, Chip, TableCell, TableRow, Tooltip } from '@mui/material'
import {  Edit as EditIcon, Delete as DeleteIcon, } from '@mui/icons-material';
import { trackActivity } from '../../../utils/mixpanel';
import { PermissionWrapper } from '../../../wrappers';
import { numberWithCommas, roundAmount } from '../../../utils';

const LLPList = ({ item, bulk, onEdit, onView, onDelete, viewFile, toggleBulkOps, isSvApproved, isClaimApproved, hideActionsColumn }) => {
const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Shop Visit LLP Listing`, page_type: page_type, })
    }
  return (
    <>
      <TableRow>
        <TableCell
          sx={{
            position: 'sticky',
            left: 0,
            width: 58,
            minWidth: 58,
            backgroundColor: 'inherit',
            zIndex: 8,
          }}>
          <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "shop_visit", operationType: ['D'] }}>
            {!isClaimApproved ? <Checkbox color='primary' size='small'
              checked={bulk?.ids.find(items => items?.id === item?.id) ? true : false}
              onChange={(e) => toggleBulkOps(e.target.checked, 'single', item)}
            /> : null}
          </PermissionWrapper>
        </TableCell>
        {!hideActionsColumn ? <TableCell sx={{
          position: 'sticky',
          left: 58,
          backgroundColor: 'inherit',
          zIndex: 8,
        }}>
          <Box className="icon-container" style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
            {!isClaimApproved ? <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "shop_visit", operationType: ['U'] }}>
              {item?.status ? <Tooltip title="Edit">
                <EditIcon fontSize="small" color="primary" onClick={() => { onEdit(); handleItemClicked('EditIcon') }} sx={{ cursor: "pointer" }} />
              </Tooltip> : null}
            </PermissionWrapper> : null}
            {!isSvApproved ? <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "shop_visit", operationType: ['U'] }}>
              <Tooltip title="Delete">
                <DeleteIcon fontSize="small" color="error" onClick={() => { onDelete(); handleItemClicked('DeleteIcon') }} sx={{ cursor: "pointer" }} />
              </Tooltip>
            </PermissionWrapper> : null}
          </Box>
        </TableCell> : null}
        <TableCell >
          {item.module ? item.module : "--"}
          {item?.is_non_llp ? <Chip label="Non LLP" size="small" variant="outlined" sx={{ ml: 1, fontSize: '0.7rem', height: '18px', width: '60px', background: '#ebebeb' }} /> : null}
        </TableCell>
        <TableCell >{item.description ? item.description : "--"}</TableCell>
        <TableCell >{item.part_number ? item.part_number : "--"}</TableCell>
        <TableCell >{item.cycles_max_limit ? numberWithCommas(roundAmount(item.cycles_max_limit)) : "--"}</TableCell>
        <TableCell >{item.cycles_remaining ? numberWithCommas(roundAmount(item.cycles_remaining)) : "--"}</TableCell>
        <TableCell >{item.sv_amount ? `US$${numberWithCommas(roundAmount(item.sv_amount))}` : "--"}</TableCell>
        <TableCell >{item.claim_amount ? `US$${numberWithCommas(roundAmount(item.claim_amount))}` : "--"}</TableCell>
      </TableRow>
    </>
  )
}

export default LLPList